/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
/* eslint-env node */

'use strict';

import {adapterFactory} from './adapter_factory.js';

const adapter = adapterFactory({window});
export default adapter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/webrtc-adapter/src/js/adapter_core.js
// module id = 1289
// module chunks = 0